<div
  [formGroup]="formGroup"
  class="pssr-form-control">
  @if (label() !== '') {
    <label
      [class.ng-invalid]="invalid()"
      class="pssr-form-label">
      {{ label() || ('app.forms.labels.user' | translate) }}
    </label>
  }
  <p-autocomplete
    [invalid]="invalid()"
    [readonly]="isReadOnly()"
    [suggestions]="suggestions()"
    [placeholder]="placeholder()"
    [inputStyleClass]="isReadOnly() ? 'read-only' : ''"
    [optionLabel]="getOptionLabel"
    (onClear)="onClear()"
    (onBlur)="onBlur()"
    (completeMethod)="searchUserByEmail($event)"
    formControlName="selectedUser"
    styleClass="pssr-autocomplete"
    panelStyleClass="pssr-autocomplete-overlay"
    appendTo="body">
    <ng-template
      let-item
      pTemplate="item">
      <div class="user-option">
        <span class="user-option__name">{{ getOptionLabel(item) }}</span>
        @if (hasDisplayName(item) && item?.Email) {
          <span class="user-option__email">&lt;{{ item.Email }}&gt;</span>
        }
      </div>
    </ng-template>
  </p-autocomplete>
</div>
